import React from 'react';
import {
  AuditOverview,
  OverviewContent,
  OverviewTitle,
  OverviewText,
  OverviewActions,
  AuditPanel,
  PanelHeader,
  PanelEyebrow,
  AuditStatusList,
  AuditStatusItem,
  StatusIcon,
} from './Overview.styles.jsx';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import { useNavigate } from 'react-router-dom';
import {
  FaSearch,
  FaClipboardCheck,
  FaComments,
  FaTools,
} from 'react-icons/fa';

const Overview = () => {
  const navigate = useNavigate();
  return (
    <AuditOverview>
      <OverviewContent>
        <p className="eyebrowHeader">Workplace Safety Review</p>

        <OverviewTitle>
          Understand What Is Working and Where Attention Is Needed
        </OverviewTitle>

        <OverviewText>
          A workplace safety audit gives your organization an opportunity to
          take a closer look at its current safety practices, documentation,
          procedures, and overall safety program.
        </OverviewText>

        <OverviewText>
          Yoda Safety Services works with businesses to identify strengths,
          uncover potential gaps, and provide practical guidance that can help
          support safer and more consistent workplace operations.
        </OverviewText>

        <OverviewActions>
          <PrimaryButton
            functionName={() => navigate('/contact-us')}
            span="Ask About a Safety Audit"
          />
          <SecondaryButton
            functionName={() => navigate('/training')}
            span="Explore Safety Training"
          />
        </OverviewActions>
      </OverviewContent>

      <AuditPanel>
        <PanelHeader>
          <div>
            <PanelEyebrow>Safety Audit</PanelEyebrow>
            <h3>A Practical Review of Your Safety Program</h3>
          </div>
        </PanelHeader>

        <AuditStatusList>
          <AuditStatusItem>
            <StatusIcon>
              <FaSearch />
            </StatusIcon>

            <div>
              <strong>Review Current Practices</strong>
              <span>
                Take a closer look at how workplace safety is currently managed.
              </span>
            </div>
          </AuditStatusItem>

          <AuditStatusItem>
            <StatusIcon>
              <FaClipboardCheck />
            </StatusIcon>

            <div>
              <strong>Identify Gaps</strong>
              <span>
                Highlight areas where procedures, documentation, or practices
                may need attention.
              </span>
            </div>
          </AuditStatusItem>

          <AuditStatusItem>
            <StatusIcon>
              <FaComments />
            </StatusIcon>

            <div>
              <strong>Review the Findings</strong>
              <span>
                Understand what was found and what those findings mean for your
                organization.
              </span>
            </div>
          </AuditStatusItem>

          <AuditStatusItem>
            <StatusIcon>
              <FaTools />
            </StatusIcon>

            <div>
              <strong>Plan Next Steps</strong>
              <span>
                Use practical recommendations to decide what should be improved
                or addressed.
              </span>
            </div>
          </AuditStatusItem>
        </AuditStatusList>
      </AuditPanel>
    </AuditOverview>
  );
};

export default Overview;
